import { STRINGS } from '@/constants/farmerSolutions'

const VisitKisanAppButton = () => (
  <a
    href="https://dehaat.in"
    target="_blank"
    className="bg-secondary-two-110 px-6 py-3.5 rounded-xl w-fit text-white whitespace-nowrap hover:scale-105 transition-all duration-300"
    rel="noreferrer"
  >
    {STRINGS.VISIT_KISAAN_WEB}
  </a>
)

export default VisitKisanAppButton
